/**
 * Login page with SwitchConnect branding and MSAL redirect login.
 */

import { useAuth } from "@/hooks/use-auth";
import { Button } from "@/components/ui/button";
import { GlassCard } from "@/components/sc/glass-card";
import { Logo } from "@/components/brand/logo";
import { GradientBackground } from "@/components/layout/gradient-background";

export function LoginPage() {
  const { login, isLoading } = useAuth();

  return (
    <div className="flex min-h-screen items-center justify-center relative">
      <GradientBackground />
      <GlassCard className="w-full max-w-md mx-4 text-center">
        <div className="flex justify-center mb-6">
          <Logo />
        </div>
        <h2 className="text-h1 text-sc-navy font-display mb-2">
          GDAP Access Control
        </h2>
        <p className="text-body-sm text-sc-text-muted mb-6">
          Sign in with your organizational account to manage customer access.
        </p>
        <Button
          variant="primary"
          size="lg"
          onClick={() => void login()}
          disabled={isLoading}
          className="w-full"
        >
          {isLoading ? "Signing in..." : "Sign in with Microsoft"}
        </Button>
      </GlassCard>
    </div>
  );
}
